import React, { useState, useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";
import config from "util/ApiforContext";
import RequestHandler from "util/RequestHandler";
import { ColumnHelper, RowHelper } from "util/TableHelper";
import { odata } from "../Filters/Helper";
import TosOrderTableFilter from "../Filters/TosOrderTableFilter";
import Screen from "../../util/Extensions/Screens";
import Iframe from "react-iframe";

import moment from "moment";

import {Table, Empty, Col, Modal, Row, Button, message, notification, Dropdown, Popconfirm, Tabs, Spin,   Form,
  Input, Tooltip, Tag} from "antd";
import {
  BarsOutlined,
  CloseCircleOutlined,
  DeleteOutlined,
  FilePdfOutlined,
  InfoCircleOutlined,
  SendOutlined,
  IdcardOutlined,
  MailOutlined,
  MailFilled,
  DownloadOutlined,
} from "@ant-design/icons";
import ReactTags from "react-autocomplete-tag";
import TextArea from "antd/lib/input/TextArea";

const baseFilter =
  "&$filter=(DirectiveStatusId eq 1 or DirectiveStatusId eq 7 or DirectiveStatusId eq 12) and isDeclined eq false";

const TosPayment = (props) => {
  const isInitialMount = useRef(true);

  const [selectedRows, setSelectedRows] = useState({
    keys: [],
    data: []
  });
  const [tableDataQueryOptions, setTableDataQueryOptions] = useState({
    skip: 0,
    take: 15,
    current: 1,
    filter: baseFilter,
  });

   const [tableData, setTableData] = useState({
    data: [],
    total: 0,
    loading: true,
  });

  const[loadingSendBank,setLoadingSendBank] = useState();
  const[loadingRepeat,setLoadingRepeat] = useState();
  const[selectedList,setSelectedList] = useState();
  const[directiveIdList,setDirectiveIdList] = useState();

  const [isTosAuthorize, setIsTosAuthorize] = useState(false);

  const [showDirectiveButton, setShowDirectiveButton] = useState(true);
  const [showCheckbox, setShowCheckbox] = useState(true);

  const [showDeclineDescriptionModal, setShowDeclineDescriptionModal] = useState(false);
  const [declineDescription, setDeclineDescription] = useState();
  const [declineId, setDeclineId] = useState();
  const [showDeclineDescription, setShowDeclineDescription] = useState(false);

  const [confirmLoading, setConfirmLoading] = useState(false);

  const [seconds, setSeconds] = useState(180);

  const [showOtpModal, setShowOtpModal] = useState(false);
  const [loadingOtpBtn, setLoadingOtpBtn] = useState(false);

  const [errorText, setErrorText] = useState("");
  const [otpInput, setOtpInput] = useState("");
  const [showRetryButton, setShowRetryButton] = useState(false);

  const [startInterval, setStartInterval] = useState(false);

  const [activeTosSms, setActiveTosSms] = useState(false);


  const [showApprovedUserModal, setShowApprovedUSerModal] = useState(false);

  const [approvedUsers, setApprovedUsers] = useState([]);
  const [showRetryDirectiveButton, setShowRetryDirectiveButton] = useState(false);
  const [showSendDirectiveButton, setShowSendDirectiveButton] = useState(false);
  const [sendSelectedList, setSendSelectedList] = useState();

    const [isHasDateFilter, setIsHasDateFilter] = useState(false);
  const [isLast7DaysFilterEnabled, setIsLast7DaysFilterEnabled] =
    useState(false);
  const [isLast1DayFilterEnabled, setIsLast1DayFilterEnabled] = useState(false);

  const [isModalVisiblePdf, setIsModalVisiblePdf] = useState(false);
  const [EmailVisible, setEmailVisible] = useState(true);
  const [pdfUrl, setPdfUrl] = useState("");
  const [Email, setEmail] = useState(localStorage.getItem("email") || "");
  const [pdfLoading, setPdfLoading] = useState(false);
  const [directiveNumberForPdf, setDirectiveNumberForPdf] = useState("");


  const ref = useRef();
  const intervalRef = useRef(null);
  const queueControlTimerRef = useRef(null);

  const history = useHistory();

   const getTenantParameter = () => {
    RequestHandler.get("/TenantParameter/GetByTenant").then((response) => {
      if (response) {
        setActiveTosSms(response.tosSmsOtp);

        if (
          !response.isHasDateFilter &&
          !response.isLast1DayFilterEnabled &&
          !response.isLast7DaysFilterEnabled
        ) {
          isInitialMount.current = false;
          getTableData();
        }

        setIsHasDateFilter(response.isHasDateFilter);
        setIsLast1DayFilterEnabled(response.isLast1DayFilterEnabled);
        setIsLast7DaysFilterEnabled(response.isLast7DaysFilterEnabled);
      }
    });
  };

  useEffect(() => {
    if (!isInitialMount.current) {
      getTableData();
    }
  }, [tableDataQueryOptions]);

  useEffect(() => {
    RequestHandler.get("/TenantUser/IsTosAuthorize").then((response) => {
      setIsTosAuthorize(response);
      if (!response) {
        RequestHandler.get("/User/MenuPermissions").then((menuResponse) => {
          if (!menuResponse.isAdmin) {
            history.push("/home");
          }
        });
      }
    });

    getTenantParameter();
  }, [])

  useEffect(() => {
    if (showOtpModal) {
      setSeconds(180);

      intervalRef.current =  setInterval(() => {

        setSeconds((prev) => {

          let second = prev - 1;

          if(second === 0) {
            clearInterval(intervalRef.current);
            setShowRetryButton(true);

            return 0;
          }

          return second;
        });
      }, 1000)
    }
    else {

      clearInterval(intervalRef.current);
    }
  }, [showOtpModal, startInterval])

  useEffect(() => {
      dateFilter();
    }, [isHasDateFilter, isLast1DayFilterEnabled, isLast7DaysFilterEnabled]);


  const dateFilter = () => {
    let startDate;

    if (isLast1DayFilterEnabled) {
      startDate = moment(new Date()).add(-1, "days");
    } else if (isLast7DaysFilterEnabled) {
      startDate = moment(new Date()).add(-7, "days");
    } else if (isHasDateFilter) {
      startDate = moment(new Date()).add(-1, "months");
    }


    if (startDate) {
      const newDateFilter = odata.dateRange(
            "paymentDate",
            startDate,
            new Date()
          );

      setTableDataQueryOptions((prevState) => {
        return {
          ...prevState,
          skip: 0,
          current: 1,
          take: tableDataQueryOptions.take,
          values: {
            paymentDateMin: startDate,
            paymentDateMax: new Date(),
          },
          filter: `${baseFilter} and ${newDateFilter}`,
        };
      });

      isInitialMount.current = false;
    }
  };

  const getTableData = () => {
    const { skip, take, filter } = tableDataQueryOptions;
    setTableData({
      ...tableData,
      loading: true,
    });

    RequestHandler.get(
      `/Directive?$count=true${filter}&$skip=${skip}&$top=${take}`
    ).then((response) => {
      setTableData({
        data: response.value,
        total: response["@odata.count"],
        loading: false,
      });
    });
  };
  const success = () => {
    let message= '';
    var falseList= [];
    var trueList = [];
    RequestHandler.post(
      "/Directive/SendBankOrConfirm",
      {
        directiveIds: directiveIdList,
        IsFromWeb: true
      },
      false
    ).then((res) => {
      if(res.success){

        res.data.map((item) => {
          if(item == true){
            trueList.push(true);
          }else{
            falseList.push(false);
          }
        })
        let sendMessage = trueList.length > 0 ? 'bankaya' : 'onaya';
        sendMessage = trueList.length > 0 && falseList.length > 0 ? 'onaya ve bankaya' : sendMessage;
        if(sendSelectedList.length > 1){
          message = sendSelectedList + ' numaralı talimatlarınız başarı ile ' + sendMessage + ' gönderildi.';
        }else{
          message = sendSelectedList + ' numaralı talimatınız başarı ile ' + sendMessage + ' gönderildi.';
        }

        Modal.success({
          content: message,
          onOk: onOk
        });
      }
    });

  }
  function onOk() {
    window.location.reload();
    setLoadingSendBank(false);
  }
  const paging = (p) => {
    setTableDataQueryOptions((prevState) => {
      return {
        ...prevState,
        skip: (p.current - 1) * prevState.take,
        take: p.pageSize,
        current: p.current,
      };
    });
  };
  const onClickCreateOrder = (value) => {
    setLoadingSendBank(true);
    RequestHandler.post(
      "/Directive/SendDirective",
      {
        directiveIds: value,
        IsFromWeb: true
      },
      !activeTosSms
    ).then((res) => {
      if(res.success){


        if(activeTosSms && res.data.otpCode != null) {
          setShowOtpModal(true)
        }
        else {
          success();
        }
      }else{
        setLoadingSendBank(false);
      }
    });
  };
  const onClickCreatePdf = (id, directiveNumber) => {
    const hideMessage = message.loading("Pdf indiriliyor...", 0);
    setEmailVisible(true);
    RequestHandler.get(
      `/Directive/CreatePdf?id=${id}`
    ).then((response) => {
      hideMessage();
      setPdfUrl(
        config.apiUrl.replace("/api","")+"/content/sourcepdf/tospdf/downloadpdfs/"+response
      );
      setDirectiveNumberForPdf(directiveNumber);
      setIsModalVisiblePdf(true);
    });
  };

  const onChangeEmail = (values) => {
    setEmail(values.target.value);
  };

  const handleCancelPdf = () => {
    setPdfUrl("");
    setIsModalVisiblePdf(false);
  };

  const downloadPdf = () => {
    window.open(pdfUrl, "_blank");
  };

  const sendMail = () => {
    setPdfLoading(true);
    if (Email.length > 0) {
      RequestHandler.post(
        `/Directive/SendMail`,
        { Email: Email, Path: pdfUrl, ScreenOption: Screen.screen },
        false,
        { rawResponse: true }
      ).then((res) => {
        if (res.data === "NotFound") {
          notification.error({
            message: "HATA",
            description: "Mail adresi kayıtlı değil.",
            duration: 2,
          });
          setPdfLoading(false);
        } else if (res.status == 204 || res.status == 200) {
          setPdfLoading(false);
          setIsModalVisiblePdf(false);
          notification.success({
            message: "BAŞARILI",
            description: "Mail gönderme işlemi başarılı.",
            duration: 2,
          });
        }
      });
    } else {
      notification.error({
        message: "HATA",
        description: "Mail adresi girilmedi.",
        duration: 2,
      });
      setPdfLoading(false);
    }
  };
  const onClickRetryDirective = (selectedRows) => {
    setLoadingRepeat(true);
    RequestHandler.post(
      "/Directive/RetryDirective",
      {
        directiveIds: selectedRows
      },
      true
    ).then((res) => {
      window.location.reload();
      setLoadingRepeat(false);
    });
    setTimeout(() => {
      setLoadingRepeat(false)
    }, 1000);
  };
  const onClearTableFilter = () => {
    if (
      !isHasDateFilter &&
      !isLast1DayFilterEnabled &&
      !isLast7DaysFilterEnabled
    ) {
      setTableDataQueryOptions({
        skip: 0,
        current: 1,
        take: tableDataQueryOptions.take,
        filter: baseFilter,
        values: undefined,
      });
    } else {
      dateFilter();
    }
  };

  const onFinishTableFilter = (query) => {
    setTableDataQueryOptions((prevState) => {
      return { skip: 0, current: 1, take: prevState.take, filter: query };
    });
  };

  const onTableSelectChange = (selectedKeys, selectedRecords) => {
    if (queueControlTimerRef.current) {
      clearTimeout(queueControlTimerRef.current);
    }

    if (!selectedKeys || selectedKeys.length === 0) {
      setSendSelectedList([]);
      setSelectedList([]);
      setDirectiveIdList([]);
      setSelectedRows({ keys: [], data: [] });
      setShowRetryDirectiveButton(false);
      setShowSendDirectiveButton(false);
      return;
    }

    // Checkbox her değişiminde anlık API yerine kısa debounce
    queueControlTimerRef.current = setTimeout(() => {
      let dateError = [];

      selectedRecords.forEach((item) => {
        if (
          moment(item.paymentDate).startOf("day").toDate() <
          moment().startOf("day").toDate()
        ) {
          dateError.push(item.id);
        }
      });

      RequestHandler.post(
        "/Directive/QueueControl",
        {
          directiveIds: selectedKeys,
        },
        false
      ).then((res) => {
        let isShowNotif = true;
        let keys = selectedKeys;
        if (
          selectedRows.keys.length > 0 &&
          selectedKeys.length >= tableDataQueryOptions.take
        ) {
          isShowNotif = false;
          keys = [];
        }

        let newSelectedList = [];
        let sendSelectedList = [];
        selectedRecords.forEach((item) => {
          if (keys.includes(item.id)) {
            newSelectedList.push(item.directiveNumber);
          }

          if (res.data && res.data[item.id] === true) {
            sendSelectedList.push(item.directiveNumber);
          }
        });

        if (res.success) {
          if (selectedRecords.length > 0 && isShowNotif) {
            if (dateError.length > 0) {
              notification["error"]({
                message: "Hata",
                description: `Ödeme tarihi geçmiş olan talimatlarınız banka gönderimine uygun değildir. ${moment().format(
                  "DD.MM.YYYY"
                )} tarihinden itibaren talimatlarınız gönderilebilir.`,
                duration: 2,
              });

              setShowRetryDirectiveButton(true);
              setShowSendDirectiveButton(false);
            }
          }

          if (dateError.length < 1) {
            setShowRetryDirectiveButton(true);
            setShowSendDirectiveButton(true);
          }
        } else {
          setShowRetryDirectiveButton(true);
          setShowSendDirectiveButton(false);
        }

        setSendSelectedList(sendSelectedList);
        setSelectedList(newSelectedList);
        setDirectiveIdList(keys);
        setSelectedRows({
          keys: keys,
          data: selectedRecords,
        });
      });
    }, 300);
  };

  const handleOnClickDelete = (id) => {
    RequestHandler.delete(`/Directive?id=${id}&isFromWeb=true`).then(
      (response) => {
        if (response.success) {
          getTableData();
        }
      }
    );

  }

  const handleDecline = (id) => {

    setDeclineId(id);
    setShowDeclineDescriptionModal(true);
    setConfirmLoading(false);
  }


  const handleOkDecline = () => {
    setConfirmLoading(true);
    RequestHandler.post(`/Directive/Decline`, {
      id: declineId,
      description: declineDescription,
    }).then(
      (response) => {

        if (response) {
          setDeclineId(null);
          setDeclineDescription(null);
          setShowDeclineDescriptionModal(false);

          getTableData();


        }
      }
    );
  }

  const handleCancelDecline = () => {
    setShowDeclineDescriptionModal(false);
  }

  const onTabChange = (key) => {
    let isDecline = false;

    setShowDirectiveButton(true);
    setShowCheckbox(true);

    if(key == 1) {
      setShowCheckbox(false);
      setShowDirectiveButton(false);
      setShowDeclineDescription(true);

      isDecline = true;


    }

    setTableDataQueryOptions({
      ...tableDataQueryOptions,
      skip: 0,
      take: 15,
      current: 1,
      filter: `&$filter=(DirectiveStatusId eq 1 or DirectiveStatusId eq 7) and isDeclined eq ${isDecline}`,
    });

  }

  const columns = [
    {
      title: "",
      dataIndex: "isSwiftPayment",
      width: 60,
      align: "center",
      render: (data) =>
        data ? (
          <Tooltip title="SWIFT Ödemesi">
            <Tag color="blue" style={{ margin: 0 }}>SWIFT</Tag>
          </Tooltip>
        ) : null,
    },
    {
      title: "Banka",
      dataIndex: "bankLogo",
      width: "8%",
      render: (text) => <img src={text}></img>,
    },
    {
      title: "Talimat Numarası",
      dataIndex: "directiveNumber",
    },
    {
      title: "Ödeme Tarihi",
      dataIndex: "paymentDate",
      render: (data, row, index) => moment(data).format("DD.MM.YYYY"),
    },
    {
      title: "Talimat Durumu",
      dataIndex: "directiveStatus",
      render: (data, row, index) => data,
    },
    {
      title: "Adet",
      dataIndex: "quantity",
    },
    {
      title: "Tutar",
      dataIndex: "amount",
      render: ColumnHelper.renderDecimal,
    },
    {
      title: "Para Birimi",
      dataIndex: "currencyCode",
      render: (data,row,index) => data
    },
    {
      title: "Açıklama",
      dataIndex: "description",
    },
    {
      title:"Hazırlayan Kişi",
      dataIndex: "creator",
    },
    {
      title: "Onaylayan Kişiler",
      dataIndex: "approvedUsers",
      align: "center",
      render: (data,row) => (
        <a style={{ fontSize: "130%" }}>
          <IdcardOutlined onClick={() => showApprovedUsers(data) } />
        </a>
      )
    },
    {
      title: "Kanal",
      align: "center",
      dataIndex: "isFromApi",
      render: (data) => {
        return data ? "Api" : "Panel"
      }
    },
    {
      title: "Pdf İndir",
      dataIndex: "id",
      align: "center",
      render: (data, row) => (
        <a onClick={() => {onClickCreatePdf(row.id, row.directiveNumber)}} download >
          <FilePdfOutlined style={{ color: "red", fontSize: "130%" }} />
        </a>
      ),
    },
    {
      title: "Sil",
      dataIndex: "id",
      align: "center",
      render: (data, row) => {

        if(row.isAllowDelete){
           return <Popconfirm
              title="Talimatı silmek istediğinize emin misiniz?"
              okText="Evet, sil"
              cancelText="Hayır, silme"
              onConfirm={() => handleOnClickDelete(data)}
              disabled={!row.isAllowDelete}
            >
              <a>
                <DeleteOutlined
                  style={{
                    color: !row.isAllowDelete ? "gray" : "red",
                    fontSize: "130%",
                  }}
                />
              </a>
            </Popconfirm>
        }

       return <Tooltip title={ row.isFromApi ? "API den üretilmiş kayıt, yalnızca API üzerinden silinebilir" : "Silme yetkiniz bulunmamaktadır" }><DeleteOutlined style={{ color: "gray", fontSize: "130%" }} /></Tooltip>

      },
    },
    {
      title: "Reddet",
      dataIndex: "id",
      align: "center",
      render: (data, row) => {

        if(row.isAllowDecline) {
           return  <Popconfirm
                    title="Talimatı reddetmek istediğinize emin misiniz?"
                    okText="Evet, reddet"
                    cancelText="Hayır, reddetme"
                    onConfirm={() => handleDecline(data)}
                    disabled={!row.isAllowDecline}
                  >
                    <a>
                      <CloseCircleOutlined
                        style={{
                          color: !row.isAllowDecline ? "gray" : "red",
                          fontSize: "130%",
                        }}
                      />
                    </a>
                  </Popconfirm>
         }

         return <Tooltip title={ row.isFromApi ? "API den üretilmiş kayıt, yalnızca API üzerinden reddedilebilir" : "Reddetme yetkiniz bulunmamaktadır" }><CloseCircleOutlined style={{ color: "gray", fontSize: "130%" }} /></Tooltip>

      },
    },
    {
      title: "Detay",
      dataIndex: "id",
      align: "center",
      render: (data, row) => (
        <a style={{ fontSize: "130%" }}>
          <InfoCircleOutlined
            onClick={() => history.push(`tos-sent-payment/${row.id}/${row.isDeclined}`)}
          />
        </a>
      ),
    },
  ];

  const approvedUserColumns = [
    {
      title: "İsim Soyisim",
      dataIndex: "fullName",
    },
    {
      title: "Onaylama Tarihi",
      dataIndex: "approvedDateTime",
    }
  ];

  const detailColumns = [{
    title: "Reddetme Sebebi",
    dataIndex: "declineDescription",
  }];


  const sendOtp = () => {
    RequestHandler.post(
      `/Directive/ResendOtp?directiveId=${directiveIdList}`,
      true
    ).then((res) => {
      setStartInterval(true);
      setShowRetryButton(false);
    });
  }

  const onOtpConfirm = () => {
    ref.current.submit();
  }
  const handleCancelOtpModal = () => {
    setShowOtpModal(false)
    setLoadingSendBank(false);
    setStartInterval(false);
    setShowRetryButton(false);
  };

  const otpFormFinish = (values) => {
    setConfirmLoading(true);
    clearInterval(intervalRef)


    RequestHandler.post(
      `/Directive/VerifyOtp?otpCode=${values.otp}&directiveId=${directiveIdList}`,
      true
    ).then((res) => {
      if(res.success){
        setShowOtpModal(false);
        setLoadingSendBank(false);
        setConfirmLoading(false);
        setShowRetryButton(false);
        success();
      }else{
        setLoadingSendBank(false);
        setConfirmLoading(false);
      }
    });
  }

  const onChangeOtpValue = (e) => {
    setErrorText("")
    setOtpInput(e.target.value)
  }


  const showApprovedUsers = (users) => {
    setApprovedUsers(users);
    setShowApprovedUSerModal(true);
  }


  return (
    <>
      <Row>
        <Col xs={24} md={12} lg={16}>
          <p style={{ fontSize: "120%", marginTop: -5 }}>
            <BarsOutlined /> TALİMAT LİSTESİ
          </p>
        </Col>

        {
          showDirectiveButton ?  <Col xs={24} md={12} lg={8} style={{ textAlign: "right" }}>
            <Button  disabled={selectedRows.keys.length > 0  && isTosAuthorize && showRetryDirectiveButton ? false : true} loading={loadingRepeat} onClick={() => {onClickRetryDirective(selectedRows.keys)}} style={{ marginBottom: 0 }}>
              <SendOutlined /> Talimatı Tekrarla
            </Button>
            <Button  disabled={selectedRows.keys.length > 0 && isTosAuthorize && showSendDirectiveButton  ? false : true} loading={loadingSendBank}  onClick={() => {onClickCreateOrder(selectedRows.keys)}} style={{ marginBottom: 0 }}>
              <SendOutlined /> Onaya/Bankaya Gönder
            </Button>
          </Col> : <></>
        }

      </Row>

      <TosOrderTableFilter
        onClearFilter={onClearTableFilter}
        onFinishFilter={onFinishTableFilter}
        style={{ marginTop: 12, marginBottom: 12 }}
        data={tableDataQueryOptions.values}
        extraText={
          isHasDateFilter
            ? "Varsayılan olarak son 1 aylık veri listelenmektedir."
            : isLast1DayFilterEnabled
            ? "Varsayılan olarak son 1 günlük veri listelenmektedir."
            : isLast7DaysFilterEnabled
            ? "Varsayılan olarak son 7 günlük veri listelenmektedir."
            : ""
        }
      />


      <Tabs
        defaultActiveKey={tableDataQueryOptions.activeTab}
        onChange={onTabChange}
      >
        <Tabs.TabPane tab="Aktif Talimat Listesi" key="0" />
        <Tabs.TabPane tab=" Reddedilmiş Talimat Listesi" key="1" />
      </Tabs>


      <Row id="tableArea">
        <Col span={24}>
          <Table
            columns={columns}
            rowSelection={showCheckbox ? {
              type: activeTosSms ? "radio" : "checkbox",
              selectedRowKeys: selectedRows.keys,
              selectedRows:selectedRows,
              onChange: onTableSelectChange,
              getCheckboxProps: (record) => ({
                disabled: !isTosAuthorize
              }),
              renderCell: (checked, record, index, originNode) => {
                const isDisabled =  !isTosAuthorize;

                let tooltipMessage = "";
                if (!isTosAuthorize) {
                  tooltipMessage = "Seçim yetkiniz bulunmuyor.";
                }

                if (isDisabled) {
                  return (
                    <Tooltip title={tooltipMessage}>
                      <span style={{ display: 'inline-block', cursor: 'not-allowed' }}>
                        {originNode}
                      </span>
                    </Tooltip>
                  );
                }

                return originNode;
              }

            }: undefined}
            locale={{
              emptyText: (
                <Empty
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                  description="Veri Yok"
                />
              ),
            }}
            style={{ overflowX: "auto", maxHeight: "100%", width: "100%" }}
            rowKey="id"
            filterable={true}
            sortable={true}
            pageable={true}
            onChange={paging}
            pagination={{
              defaultPageSize: tableDataQueryOptions.take,
              showSizeChanger:true,
              pageSizeOptions: ["15", "25", "50", "100"],
              total: tableData.total,
              current: tableDataQueryOptions.current,
            }}
            dataSource={tableData.data}
            loading={tableData.loading}
            size="small"
            expandable={
              showDeclineDescription && {
                expandedRowRender: (row) =>
                  RowHelper.renderRowDetail({
                    data: row,
                    columns: detailColumns,
                  }),
              }
            }
          />
        </Col>
      </Row>

        <Modal
          title="Reddetme sebebini açıklayınız"
          width={600}
          style={{ height: 1000 }}
          visible={showDeclineDescriptionModal}
          onOk={handleOkDecline}
          onCancel={handleCancelDecline}
          okText="Reddet"
          confirmLoading={confirmLoading}
        >
          <TextArea  autoSize={{ minRows: 3, maxRows: 5 }} value={declineDescription} onChange={(el) => setDeclineDescription(el.target.value)} />
        </Modal>


      <Modal maskClosable={false} visible={showOtpModal} onOk={onOtpConfirm} okText="Onayla" keyboard={false} cancelText="İptal" onCancel={handleCancelOtpModal} confirmLoading={confirmLoading}>
        <p style={{ marginTop: 10, textAlign: 'center', fontSize: 16 }}> Lütfen telefonunuza gelen şifreyi <b>{seconds}</b> saniye içinde girin; </p>

        <Form
          onFinish={otpFormFinish}
          fields={[
            { name: "otp", value: otpInput },
          ]}
          ref={ref}
        >
          <Form.Item
            name="otp"
          >
            <Input onChange={onChangeOtpValue} type='text' maxLength={6}
                   autoComplete="off"
                   style={{ marginTop: 40 }} onKeyPress={(event) => {
              if (!/[0-9]/.test(event.key)) {
                event.preventDefault();
              }
              if (event.key === "Enter") {
                ref.current.submit();
              }
            }} />


          </Form.Item>
          <Row style={{ marginBottom: -25 }}>
            <Col span={17}></Col>
            <Col span={7}>
              {
                showRetryButton ? <>
                  <Button onClick={sendOtp}>
                    Tekrar Gönder
                  </Button>
                </> : <></>
              }

            </Col>
          </Row>
        </Form>
        <p style={{ color: 'darkred', textAlign: 'center', fontWeight: 600 }}>{errorText}</p>
      </Modal>

      <Modal visible={showApprovedUserModal} footer={false} onCancel={() => { setShowApprovedUSerModal(false) }} >

        <Table
          columns={approvedUserColumns}
          locale={{
            emptyText: (
              <Empty
                image={Empty.PRESENTED_IMAGE_SIMPLE}
                description="Veri Yok"
              />
            ),
          }}
          style={{ overflowX: "auto", maxHeight: "100%", width: "100%" }}
          rowKey="approvedDateTime"
          dataSource={approvedUsers}
          loading={tableData.loading}
          size="small"
        />
      </Modal>

      <Modal
        title={`${directiveNumberForPdf} no'lu Talimat`}
        width={1000}
        style={{ height: 1000 }}
        visible={isModalVisiblePdf}
        onCancel={handleCancelPdf}
        footer={null}
      >
        <Form
          name="directivePdfMail"
          initialValues={{
            remember: true,
          }}
          fields={[{ name: "Email", value: Email }]}
        >
          <Row>
            <Col span={20}></Col>
            <Col span={2}>
              {EmailVisible ? (
                <MailOutlined
                  style={{ fontSize: 20, marginBottom: 20 }}
                  onClick={() => setEmailVisible(!EmailVisible)}
                />
              ) : (
                <MailFilled
                  style={{ fontSize: 20, marginBottom: 20 }}
                  onClick={() => setEmailVisible(!EmailVisible)}
                />
              )}
            </Col>
            <Col span={2}>
              <DownloadOutlined
                style={{ fontSize: 20, marginBottom: 20 }}
                onClick={() => downloadPdf()}
              />
            </Col>
          </Row>
          <Row hidden={EmailVisible}>
            <Col span={18}>
              <Form.Item
                label="Mail Adresi"
                name="Email"
                style={{ width: "100%" }}
              >
                <Input value={Email} onChange={onChangeEmail} />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item>
                <Button
                  type="primary"
                  onClick={() => sendMail()}
                  loading={pdfLoading}
                >
                  Gönder
                </Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
        <Iframe
          url={pdfUrl}
          width="100%"
          height="1000px"
          id="directivePdfPreview"
          className="myClassname"
          display="initial"
          position="relative"
        />
      </Modal>
    </>
  );
};

export default TosPayment;
